import { useSelector } from "react-redux";
import { useMemo } from "react";

import { getCurrentFeatureId, getSelectedFeatures } from "../../../ducks/selectFeatures/selectors";
import { getFeatureToShow, getLayerToShow } from "../../../ducks/showFeature/selectors";
import { featureId } from "../../../ducks/selectFeatures/utils";
import { useSelectFeaturesLayerName } from "../../../hooks/selectFeatures/useSelectFeaturesLayerName";
import { useGeometrySelection } from "../../../hooks/geometrySelection/useGeometrySelection";

export const useFeatureToShow = () => {
  const selectedFeatures = useSelector(getSelectedFeatures);
  const [geometrySelection] = useGeometrySelection();
  const currentFeatureId = useSelector(getCurrentFeatureId);
  const featureToShow = useSelector(getFeatureToShow);
  const [selectFeaturesLayerName] = useSelectFeaturesLayerName();
  const layerToShow = useSelector(getLayerToShow);

  const currentSelectedFeature = useMemo(
    () => selectedFeatures[selectFeaturesLayerName]?.find(feature => featureId(feature) === currentFeatureId),
    [selectedFeatures, selectFeaturesLayerName, currentFeatureId],
  );

  return {
    feature: currentSelectedFeature || featureToShow,
    layerName: layerToShow,
    loading: featureToShow ? false : geometrySelection.loading,
  } as const;
};
